import { getTranslate} from "@/app/shared/translate-helper";

export default function SelectData() {
	const $translate = getTranslate();
	return {
		layer1ThicknessVectorType1: [
			{
				value: '5',
				name: '5'
			},
			{
				value: '6',
				name: '6'
			},
			{
				value: '7',
				name: '7'
			},
			{
				value: '8',
				name: '8'
			},
			{
				value: '9',
				name: '9'
			},
			{
				value: '10',
				name: '10'
			},
			{
				value: '11',
				name: '11'
			}
		],
		layer2ThicknessVectorType1: [
			{
				value: '15',
				name: '15'
			},
			{
				value: '16',
				name: '16'
			},
			{
				value: '17',
				name: '17'
			},
			{
				value: '18',
				name: '18'
			},
			{
				value: '19',
				name: '19'
			},
			{
				value: '20',
				name: '20'
			},
			{
				value: '25',
				name: '25'
			},
			{
				value: '30',
				name: '30'
			}
		],
		layer3ThicknessVectorType1: [
			{
				value: '15',
				name: '15'
			},
			{
				value: '20',
				name: '20'
			},
			{
				value: '25',
				name: '25'
			},
			{
				value: '30',
				name: '30'
			},
			{
				value: '35',
				name: '35'
			},
			{
				value: '40',
				name: '40'
			}
		],
		subgradeThicknessVectorType1: [
			{
				value: '0',
				name: '0'
			}
		],

		layer1PoissonVectorType1: [
			{
				value: '0.30',
				name: '0,30'
			}
		],
		layer2PoissonVectorType1: [
			{
				value: '0.35',
				name: '0,35'
			}
		],
		layer3PoissonVectorType1: [
			{
				value: '0.35',
				name: '0,35'
			}
		],
		subgradePoissonVectorType1: [
			{
				value: '0.40',
				name: '0,40'
			}
		],

		layer1ModuleVectorType1: [
			{
				value: '35000',
				name: '35000'
			},
			{
				value: '45000',
				name: '45000'
			}
		],
		layer2ModuleVectorType1: [
			{
				value: '2000',
				name: '2000'
			},
			{
				value: '3000',
				name: '3000'
			},
			{
				value: '4000',
				name: '4000'
			}
		],
		layer3ModuleVectorType1: [
			{
				value: '1000',
				name: '1000'
			},
			{
				value: '1500',
				name: '1500'
			},
			{
				value: '2000',
				name: '2000'
			},
			{
				value: '2500',
				name: '2500'
			}
		],
		subgradeModuleVectorType1: [
			{
				value: '400',
				name: '400'
			},
			{
				value: '500',
				name: '500'
			},
			{
				value: '600',
				name: '600'
			},
			{
				value: '700',
				name: '700'
			},
			{
				value: '800',
				name: '800'
			},
			{
				value: '900',
				name: '900'
			},
			{
				value: '1000',
				name: '1000'
			},
			{
				value: '1100',
				name: '1100'
			},
			{
				value: '1200',
				name: '1200'
			}
		],

		// Semirrigido -----------------------------------------------

		layer1ThicknessVectorType2: [
			{
				value: '5',
				name: '5'
			},
			{
				value: '6',
				name: '6'
			},
			{
				value: '7',
				name: '7'
			},
			{
				value: '8',
				name: '8'
			},
			{
				value: '9',
				name: '9'
			},
			{
				value: '10',
				name: '10'
			},
			{
				value: '11',
				name: '11'
			}
		],
		layer2ThicknessVectorType2: [
			{
				value: '10',
				name: '10'
			},
			{
				value: '15',
				name: '15'
			},
			{
				value: '20',
				name: '20'
			},
			{
				value: '25',
				name: '25'
			},
			{
				value: '30',
				name: '30'
			}
		],
		layer3ThicknessVectorType2: [
			{
				value: '10',
				name: '10'
			},
			{
				value: '15',
				name: '15'
			},
			{
				value: '20',
				name: '20'
			},
			{
				value: '25',
				name: '25'
			},
			{
				value: '30',
				name: '30'
			},
			{
				value: '35',
				name: '35'
			},
			{
				value: '40',
				name: '40'
			}
		],
		subgradeThicknessVectorType2: [
			{
				value: '0',
				name: '0'
			}
		],

		layer1PoissonVectorType2: [
			{
				value: '0.30',
				name: '0,30'
			}
		],
		layer2PoissonVectorType2: [
			{
				value: '0.20',
				name: '0,20'
			}
		],
		layer3PoissonVectorType2: [
			{
				value: '0.35',
				name: '0,35'
			}
		],
		subgradePoissonVectorType2: [
			{
				value: '0.40',
				name: '0,40'
			}
		],

		layer1ModuleVectorType2: [
			{
				value: '35000',
				name: '35000'
			},
			{
				value: '45000',
				name: '45000'
			}
		],
		layer2ModuleVectorType2: [
			{
				value: '50000',
				name: '50000'
			},
			{
				value: '70000',
				name: '70000'
			},
			{
				value: '90000',
				name: '90000'
			},
			{
				value: '110000',
				name: '110000'
			},
			{
				value: '130000',
				name: '130000'
			}
		],
		layer3ModuleVectorType2: [
			{
				value: '1000',
				name: '1000'
			},
			{
				value: '3000',
				name: '3000'
			},
			{
				value: '5000',
				name: '5000'
			},
			{
				value: '7000',
				name: '7000'
			}
		],
		subgradeModuleVectorType2: [
			{
				value: '400',
				name: '400'
			},
			{
				value: '500',
				name: '500'
			},
			{
				value: '600',
				name: '600'
			},
			{
				value: '700',
				name: '700'
			},
			{
				value: '800',
				name: '800'
			},
			{
				value: '900',
				name: '900'
			},
			{
				value: '1000',
				name: '1000'
			},
			{
				value: '1100',
				name: '1100'
			},
			{
				value: '1200',
				name: '1200'
			}
		],

		// Invertido -----------------------------------------------

		layer1ThicknessVectorType3: [
			{
				value: '5',
				name: '5'
			},
			{
				value: '6',
				name: '6'
			},
			{
				value: '7',
				name: '7'
			},
			{
				value: '8',
				name: '8'
			},
			{
				value: '9',
				name: '9'
			},
			{
				value: '10',
				name: '10'
			},
			{
				value: '11',
				name: '11'
			}
		],
		layer2ThicknessVectorType3: [
			{
				value: '10',
				name: '10'
			},
			{
				value: '15',
				name: '15'
			},
			{
				value: '20',
				name: '20'
			},
			{
				value: '25',
				name: '25'
			},
			{
				value: '30',
				name: '30'
			}
		],
		layer3ThicknessVectorType3: [
			{
				value: '10',
				name: '10'
			},
			{
				value: '15',
				name: '15'
			},
			{
				value: '20',
				name: '20'
			},
			{
				value: '25',
				name: '25'
			},
			{
				value: '30',
				name: '30'
			}
		],
		subgradeThicknessVectorType3: [
			{
				value: '0',
				name: '0'
			}
		],

		layer1PoissonVectorType3: [
			{
				value: '0.30',
				name: '0,30'
			}
		],
		layer2PoissonVectorType3: [
			{
				value: '0.35',
				name: '0,35'
			}
		],
		layer3PoissonVectorType3: [
			{
				value: '0.20',
				name: '0,20'
			}
		],
		subgradePoissonVectorType3: [
			{
				value: '0.40',
				name: '0,40'
			}
		],

		layer1ModuleVectorType3: [
			{
				value: '35000',
				name: '35000'
			},
			{
				value: '45000',
				name: '45000'
			}
		],
		layer2ModuleVectorType3: [
			{
				value: '2000',
				name: '2000'
			},
			{
				value: '4000',
				name: '4000'
			},
			{
				value: '6000',
				name: '6000'
			},
			{
				value: '8000',
				name: '8000'
			},
			{
				value: '10000',
				name: '10000'
			}
		],
		layer3ModuleVectorType3: [
			{
				value: '50000',
				name: '50000'
			},
			{
				value: '70000',
				name: '70000'
			},
			{
				value: '90000',
				name: '90000'
			},
			{
				value: '110000',
				name: '110000'
			},
			{
				value: '130000',
				name: '130000'
			}
		],
		subgradeModuleVectorType3: [
			{
				value: '400',
				name: '400'
			},
			{
				value: '500',
				name: '500'
			},
			{
				value: '600',
				name: '600'
			},
			{
				value: '700',
				name: '700'
			},
			{
				value: '800',
				name: '800'
			},
			{
				value: '900',
				name: '900'
			},
			{
				value: '1000',
				name: '1000'
			},
			{
				value: '1100',
				name: '1100'
			},
			{
				value: '1200',
				name: '1200'
			}
		],

		textWarningP1: $translate.instant('reduce_data.textWarningP1'),
		textWarningP2: $translate.instant('reduce_data.textWarningP2'),
		textWarningP3: $translate.instant('reduce_data.textWarningP3'),
		textOrigin: $translate.instant('reduce_data.textOrigin'),
		textAwayOrigin1: $translate.instant('reduce_data.textAwayOrigin1'),
		textAwayOrigin2: $translate.instant('reduce_data.textAwayOrigin2'),
		textAwayOrigin3: $translate.instant('reduce_data.textAwayOrigin3'),
		textWarningP4: $translate.instant('reduce_data.textWarningP4'),
		textWarningP5: $translate.instant('reduce_data.textWarningP5'),
		textWarningP6: $translate.instant('reduce_data.textWarningP6'),
		textUnderstood: $translate.instant('reduce_data.textUnderstood'),

		doNotAccept: $translate.instant('mechanical.do_not_accept'),
		subgrade: $translate.instant('mechanical.subgrade'),
		accept: $translate.instant('mechanical.accept'),
		selected: $translate.instant('mechanical.selected'),
		dnerPro0111979: $translate.instant('mechanical.dner_pro_011_1979'),
		dnerPro2691994: $translate.instant('mechanical.dner_pro_269_1994'),
		fhwa1986: $translate.instant('mechanical.fhwa_1986'),
		asphaltInstitute1976: $translate.instant('mechanical.asphalt_institute_1976'),
		balbo1993: $translate.instant('mechanical.balbo_1993'),
		ceratti1991Na: $translate.instant('mechanical.ceratti_1991_na'),
		ceratti1991La: $translate.instant('mechanical.ceratti_1991_la'),
		ceratti1991La1: $translate.instant('mechanical.ceratti_1991_la_1'),
		ceratti1991Lg1: $translate.instant('mechanical.ceratti_1991_lg_1'),
		dormonAndMetcalf1965: $translate.instant('mechanical.dormon_and_metcalf_1965'),
		asphaltInstitute1984: $translate.instant('mechanical.asphalt_institute_1984'),
		shell95reliability1985: $translate.instant('mechanical.shell_95_reliability_1985'),
		totalEquivalentThickness: $translate.instant('mechanical.total_equivalent_thickness'),
		not: $translate.instant('mechanical.not'),
		minimumRequirement: $translate.instant('mechanical.minimum_requirement'),
		pavmentThickness: $translate.instant('mechanical.pavment_thickness'),
		dner: $translate.instant('mechanical.dner'),
		tensileStrength: $translate.instant('mechanical.tensile_strength'),
		mechanisticAnalysis: $translate.instant('mechanical.mechanistic_analysis'),
		inputData: $translate.instant('mechanical.input_data'),
		thickness: $translate.instant('mechanical.thickness'),
		poissonRatio: $translate.instant('mechanical.poisson_ratio'),
		modulus: $translate.instant('mechanical.modulus'),
		flexible: $translate.instant('mechanical.flexible'),
		pavmentType: $translate.instant('mechanical.pavment_type'),
		inverted: $translate.instant('mechanical.inverted'),
		semiRigid: $translate.instant('mechanical.semi_rigid'),
		layer: $translate.instant('mechanical.layer'),
		parameter: $translate.instant('mechanical.parameter'),
		predictedValue: $translate.instant('mechanical.predicted_value'),
		model: $translate.instant('mechanical.model'),
		traffic: $translate.instant('mechanical.traffic'),
		allowaleValue: $translate.instant('mechanical.allowale_value'),
		accepted: $translate.instant('mechanical.accepted'),
		verification: $translate.instant('mechanical.verification'),
		calculator: $translate.instant('mechanical.calculate'),
		first_layer: $translate.instant('mechanical.fist_layer'),
		second_layer: $translate.instant('mechanical.second_layer'),
		third_layer: $translate.instant('mechanical.third_layer'),
		selectAnItem: $translate.instant('action.selectAnItem')
	};
}
